<template>
  <div class="default-layout">
    <div class="header-wrap"><default-header></default-header></div>
    <div class="sidebar-wrap">
      <template v-for="item in sidebarRouterList">
        <default-sidebar
          :key="item.type"
          v-if="
            ($route.meta.sidebarLayer &&
              $route.meta.sidebarLayer === item.type) ||
              (!$route.meta.sidebarLayer &&
                item.type === $projectConfig.sidebarLayer.otherLayer)
          "
          :sidebar-router="item.routerList ? item.routerList : []"
        >
        </default-sidebar>
      </template>
    </div>
    <div class="page-content-wrap">
      <transition name="down" mode="out-in">
        <router-view :key="$route.meta.category"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import DefaultHeader from './DefaultHeader.vue'
import DefaultSidebar from './DefaultSidebar.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    DefaultHeader,
    DefaultSidebar
  },

  computed: {
    ...mapGetters(['sidebarRouterList'])
  }
}
</script>

<style lang="less" scoped>
@import '../../style/mixin.less';
@import '../../style/variable.less';

.default-layout {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  .header-wrap {
    height: @headerHeight;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
  }
  .sidebar-wrap {
    box-shadow: 1px 0 3px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: @headerHeight;
    bottom: 0;
    left: 0;
    width: @sidebarWidth;
  }
  .page-content-wrap {
    margin-top: @headerHeight;
    margin-left: @sidebarWidth;
    height: calc(~'100% - @{headerHeight}');
    width: calc(~'100% - @{sidebarWidth}');
    overflow: hidden;
    .default-header {
      width: 100%;
      line-height: 50px;
      font-size: 18px;
      font-weight: bolder;
      color: #333;
      box-shadow: 0 0 5px rgba(200, 200, 200, 0.6);
      text-indent: 1em;
    }
    .search-input {
      margin: 40px 25px;
    }
  }
}
</style>
